<template>
  <div>
    <div>
      <legend>Detail Pemohon</legend>
      <div class="row">
        <div class="col-md-6">
          <label>NIK Pemohon</label>
          <b-form-input disabled v-model="dataPermohonan.nik_pemohon"></b-form-input>
        </div>
        <div class="col-md-6">
          <label>Nama Pemohon</label>
          <b-form-input disabled v-model="dataPermohonan.nama_pemohon"></b-form-input>
        </div>
        <div class="col-md-6 mt-3">
          <label>Jabatan Pemohon</label>
          <b-form-input disabled v-model="dataPermohonan.jabatan_pemohon"></b-form-input>
        </div>

        </div>

        <legend class="mt-4">Detail Instansi/Perusahaan/Perorangan</legend>
        <div class="row">

        <div class="col-md-6">
          <label>Nama</label>
          <b-form-input disabled v-model="dataPermohonan.instansi_pemohon"></b-form-input>
        </div>

        <div class="col-md-6">
          <label>NPWP</label>
          <b-form-input disabled v-model="dataPermohonan.npwp_pemohon"></b-form-input>
        </div>

       
        <div class="col-md-6 mt-3">
          <label>Alamat</label>
          <b-form-textarea disabled v-model="dataPermohonan.alamat_pemohon"></b-form-textarea>
        </div>

        <div class="col-md-6 mt-3">
          <label>No. Handphone</label>
          <b-form-input disabled v-model="dataPermohonan.no_hp_pemohon"></b-form-input>
        </div>

        <div class="col-md-6 mt-3">
          <label>No. Telphone</label>
          <b-form-input disabled v-model="dataPermohonan.no_telepon_pemohon"></b-form-input>
        </div>

        <div class="col-md-6 mt-3">
          <label>Email</label>
          <b-form-input disabled v-model="dataPermohonan.email_pemohon"></b-form-input>
        </div>

        <b-col md="6" class="mt-3">
            <b-form-group>
              <label>Nilai Investasi</label>
              <currency-input readonly v-model="dataPermohonan.nilai_investasi" name="Nilai Investasi"  />

              <span class="text-danger" v-if="errors.has('form-1.Nilai Investasi')">
                {{ errors.first('form-1.Nilai Investasi') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6" class="mt-3">
            <b-form-group>
              <label>Serapan Tenaga Kerja</label>
              <b-form-input readonly v-validate="'required'" name="Serapan Tenaga Kerja" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Serapan Tenaga Kerja'),
              }" id="name" type="number" v-model="dataPermohonan.serapan_tenaga_kerja" />
              <span class="text-danger" v-if="errors.has('form-1.Serapan Tenaga Kerja')">
                {{ errors.first("form-1.Serapan Tenaga Kerja") }}
              </span>
            </b-form-group>
          </b-col>

        </div>

        <legend class="mt-4">Detail Permohonan</legend>
        <div class="row">

        <div class="col-md-6">
          <label>Provinsi</label>
          <v-select disabled id="default-select" v-model="dataPermohonan.provinsi"
            :reduce="(data) => data.nama_provinsi" label="nama_provinsi" :options="dataProvinsi" v-validate="'required'"
            @input="getKabupaten()" name="Provinsi" />
        </div>
        <div class="col-md-6">
          <label>Kabupaten</label>
          <v-select disabled id="default-select" v-model="dataPermohonan.kabupaten"
            :reduce="(data) => data.nama_kabupaten" label="nama_kabupaten" :options="dataKabupaten"
            v-validate="'required'" @input="getKecamatan()" name="Kabupaten" />
        </div>
        <div class="col-md-6 mt-3">
          <label>Kecamatan</label>
          <v-select disabled id="default-select" v-model="dataPermohonan.kecamatan"
            :reduce="(data) => data.nama_kecamatan" label="nama_kecamatan" :options="dataKecamatan"
            v-validate="'required'" name="Kecamatan" />
        </div>
        <div class="col-md-6 mt-3">
          <label>Jenis Kegiatan</label>
          <b-form-input disabled v-model="dataPermohonan.jenis_kegiatan"></b-form-input>
        </div>
        <!-- <div class="col-md-6 mt-3">
              <label>Skala Usaha</label>
              <v-select
              disabled
                id="default-select"
                v-model="dataPermohonan.skala_usaha"
                :options="dataSkalaUsaha"
                v-validate="'required'"
                name="Skala Usaha"
              />
            </div> -->
        <div class="col-md-6 mt-3">
          <label>Reklamasi</label>
          <v-select disabled id="default-select" v-model="dataPermohonan.reklamasi" :reduce="(data) => data.value"
            label="text" :options="dataReklamasi" v-validate="'required'" name="Reklamasi" />
        </div>
        <div class="col-md-6 mt-3">
          <label>Nama Perairan</label>
          <b-form-input disabled v-model="dataPermohonan.nama_perairan"></b-form-input>
        </div>
        <div class="col-md-6 mt-3">
          <label>PSN</label>
          <v-select disabled id="default-select" v-model="dataPermohonan.psn" :options="dataPSN" v-validate="'required'"
            name="PSN" />
        </div>
        <div class="col-md-6 mt-3">
          <label>PKPN</label>
          <b-form-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.is_pkpn"
                :options="[{value: true, text: 'PKPN'}, {value: false, text: 'Non PKPN'}]"  name="PKPN"/>
        </div>
        <b-col md="6" class="mt-3">
          <b-form-group label="Jenis Permohonan: *">
            <v-select class="custom-disabled" disabled id="default-select" v-model="dataPermohonan.jenis_pnbp" :options="[
              'Area',
              'Kabel Bawah Laut',
              'Pipa Air Bersih / Air Baku',
              'Pipa Selain Air Bersih / Air Baku',
            ]" v-validate="'required'" name="Jenis Permohonan" :multiple="true"
              :class="{ 'is-invalid': errors.has('form-1.Jenis Permohonan') }" @input="resetPNBP" />
            <span class="text-danger" v-if="errors.has('form-1.Jenis Permohonan')">
              {{ errors.first("form-1.Jenis Permohonan") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="6" class="mt-3" v-if="dataPermohonan.jenis_pnbp.includes('Area')">
          <b-form-group label="Luas (ha) *">
            <b-form-input readonly min="0" step=".01" type="number" name="Luas" :class="{
              'form-control': true,
              'is-invalid': errors.has('form-1.Luas'),
            }" v-model="dataPermohonan.luas" />
            <span class="text-danger" v-if="errors.has('form-1.Luas')">
              {{ errors.first("form-1.Luas") }}
            </span>
          </b-form-group>
        </b-col>

        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
        ">
          <b-form-group label="Panjang Kabel(di dalam Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di dalam Kws. Konservasi)(km)"
              v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has(
                  'form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)'
                ),
              }" v-model="dataPermohonan.panjang_konservasi_kabel" />
            <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Kabel(di dalam Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Kabel Bawah Laut')
        ">
          <b-form-group label="Panjang Kabel(di luar Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number" name="Panjang Kabel(di luar Kws. Konservasi)(km)"
              v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)'),
              }" v-model="dataPermohonan.panjang_nonkonservasi_kabel" />
            <span class="text-danger" v-if="errors.has('form-1.Panjang Kabel(di luar Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Kabel(di luar Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>

        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku')
        ">
          <b-form-group label="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number"
              name="Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has(
                  'form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)'
                ),
              }" v-model="dataPermohonan.panjang_konservasi_pipa_air" />
            <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Pipa Air Bersih(di dalam Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Pipa Air Bersih / Air Baku')
        ">
          <b-form-group label="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number"
              name="Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)'),
              }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_air" />
            <span class="text-danger" v-if="errors.has('form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Pipa Air Bersih(di luar Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>

        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
        ">
          <b-form-group label="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number"
              name="Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)" v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has(
                  'form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)'
                ),
              }" v-model="dataPermohonan.panjang_konservasi_pipa_lain" />
            <span class="text-danger"
              v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di dalam Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>
        <b-col md="6" class="mt-3" v-if="
          dataPermohonan.jenis_pnbp.includes('Pipa Selain Air Bersih / Air Baku')
        ">
          <b-form-group label="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)*" label-for="form">
            <b-form-input disabled min="0" step=".01" type="number"
              name="Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)" v-validate="'required'" :class="{
                'form-control': true,
                'is-invalid': errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)'),
              }" v-model="dataPermohonan.panjang_nonkonservasi_pipa_lain" />
            <span class="text-danger"
              v-if="errors.has('form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)')">
              {{ errors.first("form-1.Panjang Pipa Selain Air Bersih(di luar Kws. Konservasi)(km)") }}
            </span>
          </b-form-group>
        </b-col>

        <div class="col-md-6 mt-3">
          <label>Kedalaman (mdpl)</label>
          <b-form-input disabled v-model="dataPermohonan.kedalaman"></b-form-input>
        </div>
      </div>
      <div class="row justify-content-between mt-5">
        <div class="col-4">
          <div class="text-left">
            <!-- <b-button @click="$router.push('/app/perizinan')" variant="danger" >Back</b-button> -->
          </div>
        </div>
        <div class="col-4">
          <div class="text-right">
            <b-button @click="nextDokumen()" style="float:right" variant="primary">Selanjutnya <i class="fa fa-caret-right" />
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import CurrencyInput from '../../../../../components/CurrencyInput/CurrencyInput.vue';
export default {
  data() {
    return {
      optionsPrioritas: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
      dataReklamasi: [
        { value: true, text: 'Ya' },
        { value: false, text: 'Tidak' },
      ],
    }
  },
  components: { vSelect, CurrencyInput },
  props: {
    dataPermohonan: {
      type: Array,
      default: () => {
        return [];
      },
    },
  },
  methods: {
    nextDokumen() {
      this.$emit('nextDokumen')
    }
  }
}
</script>